import localforage from 'localforage';
import memoryStorageDriver from 'localforage-memoryStorageDriver';

localforage.defineDriver(memoryStorageDriver).then(() => {
  return localforage.setDriver(memoryStorageDriver._driver);
}).then(() => {
  console.log('Active driver: ' + localforage.driver());
  return localforage.clear();
});

export default class Storage {
  static keyFromUrlParams(url: string, params?: object): string {
    let key = url;
    if (params) {
      for (const k in params) {
        if (params.hasOwnProperty(k)) {
          key += params[k];
        }
      }
    }
    // Base-64
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
    const regex = /%[A-Z0-9]{2}/g;
    return btoa(encodeURIComponent(key).replace(regex, ''))
      .replace(/=/g, '');
  }

  static get(key: string): Promise<any> {
    return localforage.getItem(key).then((v: string) => {
      try {
        const data = JSON.parse(v);
        return data;
      } catch (e) {
        return e;
      }
    });
  }

  static set(key: string, value: any) {
    return localforage.setItem(key, JSON.stringify(value));
  }

  static delete(key: string) {
    return localforage.removeItem(key);
  }

  static keys() {
    return localforage.keys();
  }

  static clear() {
    return localforage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/services/storage.ts